const CartModal = {
  el: {
    cartModal: document.querySelector('.cart-modal'),
    cartModalClose: document.querySelector('.cart-modal__close'),
  },
  init() {
    if (this.el.cartModal) {
      this.el.cartModalClose.addEventListener('click', () => {
        if (this.el.cartModal.classList.contains('open')) {
          this.el.cartModal.classList.remove('open')
        }
      })
    }
  }
}

export default CartModal